import React, { Component } from 'react';
import { getConfigValue } from '../Common/Providers/ConfigsApi';
import { getStoreCode } from '../Store/Store.APP_ENV.js';
import config from '../../config';

function withGlobalShippingCredit(WrappedComponent) {
    return class WithGlobalShippingCredit extends Component {
        constructor(props) {
            super(props);

            this.state = {
                globalShippingCreditEnabled: undefined,
                shippingCreditCurrency: null,
                shippingCreditBalance: 0,
                shippingCreditNearestExpiry: null,
                creditFaqUrl: null,
            };
        }

        componentDidMount() {
            Promise
                .all([this.isGlobalShippingCreditEnabled(), this.getShippingCreditSummary()])
                .then(([globalShippingCreditEnabled, shippingCreditSummary]) => this.setState({
                    globalShippingCreditEnabled,
                    shippingCreditCurrency: shippingCreditSummary.currency,
                    shippingCreditBalance: shippingCreditSummary.balance,
                    shippingCreditNearestExpiry: shippingCreditSummary.nearest_expiry,
                    creditFaqUrl: shippingCreditSummary.faq_url
                }));
        }

        async isGlobalShippingCreditEnabled() {
            try {
                let storeCodes = await getConfigValue('global-shipping-credit');
                storeCodes = storeCodes.map(storeCode => storeCode.trim().toLowerCase());
                return storeCodes.includes(getStoreCode().toLowerCase());
            } catch (error) {
                return false;
            }
        }

        async getShippingCreditSummary() {
            try {
                const { data: { currency, balance, nearest_expiry, faq_url } } = await $.get(`${config.localeApi}/shipping_credit_summary`);

                return {
                    currency,
                    balance,
                    nearest_expiry,
                    faq_url
                };
            } catch (error) {
                return {
                    currency: null,
                    balance: 0,
                    nearest_expiry: null,
                    faq_url: ''
                };
            }
        }

        render() {
            return <WrappedComponent
                {...this.props}
                globalShippingCreditEnabled={this.state.globalShippingCreditEnabled}
                shippingCreditCurrency={this.state.shippingCreditCurrency}
                shippingCreditBalance={this.state.shippingCreditBalance}
                shippingCreditNearestExpiry={this.state.shippingCreditNearestExpiry}
                creditFaqUrl={this.state.creditFaqUrl}
            />
        }
    }
}

export default withGlobalShippingCredit;



// WEBPACK FOOTER //
// ./src/GlobalShippingCredit/withGlobalShippingCredit.js